"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHumboldtVersion = void 0;
const getHumboldtVersion = () => require("../package.json").version;
exports.getHumboldtVersion = getHumboldtVersion;
//# sourceMappingURL=version.js.map